import { ref } from "vue"

// Module-level singleton like useGroupDialog: «Настройки уведомлений…» is opened from unrelated
// menus (sidebar group "...", the group banner menu, the mobile group list), while the dialog
// itself is mounted once in app.vue.
const isOpen = ref(false)
const groupId = ref<string | null>(null)

export function useNotificationSettingsDialog() {
  function open(id: string) {
    groupId.value = id
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return { isOpen, groupId, open, close }
}
